/* eslint-disable no-case-declarations */
import React, { Component } from "react";
import loader from "../loader.gif";
import logo from "../logo.png";
import AcademicInterest from "./AcademicInterest";
import GovernmentInformation from "./GovernmentInformation";
import PersonalInformation from "./PersonalInformation";
import WorkExperience from "./WorkExperience";
import Address from "./Address";
import Contact from "./Contact";
import ParentsInformation from "./ParentsInformation";
import GuardianInformation from "./GuardianInformation";
import HealthInformation from "./HealthInformation";
import Sources from "./Sources";
import FundingSource from "./FundingSource";
import Policies from "./Policies";
import PropTypes from "prop-types";
import EducationHistoryUndergraduate from "./EducationHistoryUndergraduate";
import EducationHistoryGraduate from "./EducationHistoryGraduate";
import { emailCheck } from "../constants";
import submit from "../submit.gif";
import TestScores from "./TestScores";
export default class SuccessPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saveProcessing: false,
      nextProcessing: false,
      acceptedPolicies: false,
      isBlocking: true,
      loading: true,
      program: "",
      nationality: 1,
      countryData: [],
      email: "",
      fname: "",
      lName: "",
      mName: "",
      motherInfo: [],
      fatherInfo: [],
      guardianInfo: [],
      saved: false,
      count: [1, 1, 1, 1, 1, 1, 1, 1],
      sections: [
        {
          name: "Applicant Personal Information",
          open: false,
        },
        {
          name: "Official Identification",
          open: false,
        },
        {
          name: "Education",
          open: false,
        },
        {
          name: "Program of Study",
          open: false,
        },
        {
          name: "Work Experience",
          open: false,
        },
        // {
        //   name: "Address",
        //   open: false,
        // },
        {
          name: "Applicant’s Contact Information",
          open: false,
        },
        // {
        //   name: 'Parents Information',
        //   open: false
        // },
        // {
        //   name: "Legal Guardian Information",
        //   open: false,
        // },

        {
          name: "English Proficiency Assessment",
          open: false,
        },
        // {
        //   name: "Health Information",
        //   open: false,
        // },
        {
          name: "Sources",
          open: false,
        },
        {
          name: "Funding Sources",
          open: false,
        },
        {
          name: "Policies",
          open: false,
        },
      ],
      activeSections: [
        {
          name: "Applicant Personal Information",
          open: false,
        },
        {
          name: "Official Identification",
          open: false,
        },
        {
          name: "Education",
          open: false,
        },
        {
          name: "Program of Study",
          open: false,
        },
        {
          name: "Work Experience",
          open: false,
        },
        // {
        //   name: "Address",
        //   open: false,
        // },
        {
          name: "Applicant’s Contact Information",
          open: false,
        },
        // {
        //   name: "Parents Information",
        //   open: false,
        // },
        // {
        //   name: "Legal Guardian Information",
        //   open: false,
        // },

        {
          name: "English Proficiency Assessment",
          open: false,
        },
        // {
        //   name: "Health Information",
        //   open: false,
        // },
        {
          name: "Sources",
          open: false,
        },
        {
          name: "Funding Sources",
          open: false,
        },
        {
          name: "Policies",
          open: false,
        },
      ],
      selectedFundingSource: "",
      incompleteApplicationId: 0,
      selectedCategory: "",
      addressType: 0,
      line1: "",
      line2: "",
      country: 0,
      city: 0,
      dateOfBirth: 0,
      countryOfBirth: 0,
      gender: 0,
      siblingFName: "",
      siblingMName: "",
      siblingLName: "",
      siblingTKHNumber: "",
      arabicData: [],
      contactInformation: [],
      educationHistory: [],
      workExperienceInfos: [],

      selectedProgram: 0,
      programOfStudyId: "",
      entryTerm: 0,
      selectedUniversity: 0,
      selectedSchedule: 0,

      Company: "",
      Industry: 0,
      Position: 0,
      StartDate: "",
      EndDate: "",

      selectedSecondUniversity: 0,
      selectedSecondProgram: 0,
      selectedSecondMajor: 0,
      selectedLevel: 0,
      selectedSecondLevel: 0,

      description: "",
      secondDescription: "",
      nationalIdNumber: "",
      passportNumber: "",
      passportCountry: 0,
      passportExpiry: "",
      policyError: "",
      testTypeError: "",
      color: "red",
      personalInformation: {},
      errorPI: {},
      ai: {},
      fs: {},
      errorAI: {},
      governmentInformation: {},
      errorGI: {},
      errorWE: {},
      address: {},
      errorAdd: {},
      contactInformations: {},
      errorContact: {},
      parentsInformation: {},
      errorParent: {},
      guardianInformation: {},
      errorGuard: {},
      workExperienceInformation: {},
      educationHistorys: {},
      errorEdu: {},
      testScores: {},
      testScoresProp: {},
      errorTest: [],
      errorAcad: {},
      healthInformation: {},
      errorHI: {},
      sources: {},
      errorSources: {},
      sourceInformation: {},
      undergraduate: null,
      graduate: null,
      fatherId: null,
      motherId: null,
      ahsd: null,
      ib: null,
      anata: null,
      igcse: null,
      gcse: null,
      otherSource: null,
      selectedLanguage: 0,
    };
    this.toggleAccordion = this.toggleAccordion.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.collectState = this.collectState.bind(this);
    this.prepareState = this.prepareState.bind(this);
    this.conditionCheck = this.conditionCheck.bind(this);
    this.personalInformationCheck = this.personalInformationCheck.bind(this);
    this.educationHistoryCheck = this.educationHistoryCheck.bind(this);
    this.academicInterestCheck = this.academicInterestCheck.bind(this);
    this.workExperienceCheck = this.workExperienceCheck.bind(this);
    this.governmentInformationCheck =
      this.governmentInformationCheck.bind(this);
    this.addressCheck = this.addressCheck.bind(this);
    this.contactCheck = this.contactCheck.bind(this);
    this.parentsInformationCheck = this.parentsInformationCheck.bind(this);
    this.guardianInformationCheck = this.guardianInformationCheck.bind(this);
    this.testScoresCheck = this.testScoresCheck.bind(this);
    this.healthInformationCheck = this.healthInformationCheck.bind(this);
    this.sourcesCheck = this.sourcesCheck.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.submit = this.submit.bind(this);
    this.getDefaultValue = this.getDefaultValue.bind(this);
  }

  async componentDidMount() {
    this.setState({
      incompleteApplicationId:
        parseInt(this.props.incompleteApplicationId) ||
        parseInt(sessionStorage.getItem("id")),
      token:
        this.props.token ||
        sessionStorage.getItem("token") ||
        sessionStorage.getItem("token"),
    });
    this.setState({
      loading: false,
      error: "your application is submitted. ",
    });
    window.addEventListener("beforeunload", this.unloadEvent);
  }

  unloadEvent(e) {
    e.preventDefault();
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.unloadEvent);
  }

  prepareState() {
    const {
      selectedFundingSource,
      selectedSecondUniversity,
      selectedSecondProgram,
      selectedSecondMajor,
      selectedLevel,
      selectedSecondLevel,
      selectedProgram,
      programOfStudyId,
      entryTerm,
      selectedUniversity,
      selectedSchedule,
      description,
      secondDescription,
      guardianInfo,
      workExperienceInfos,
      fatherInfo,
      motherInfo,
      contactInformation,
      email,
      educationHistory,
      sources,
      undergraduate,
      fatherId,
      motherId,
      otherSource,
      testScoresProp,
      selectedLanguage,
    } = this.state;

    const data1 = {
      selectedFundingSource: selectedFundingSource,
    };

    // Program of Study
    const data = {
      selectedSecondUniversity: selectedSecondUniversity,
      selectedSecondProgram: selectedSecondProgram,
      selectedSecondMajor: selectedSecondMajor,
      selectedProgram: selectedProgram,
      selectedMajor: programOfStudyId,
      selectedEntryTerm: entryTerm,
      selectedUniversity: selectedUniversity,
      selectedSchedule: selectedSchedule,

      description: description,
      secondDescription: secondDescription,
      selectedLevel: selectedLevel,
      selectedSecondLevel: selectedSecondLevel,
      selectedLanguage: selectedLanguage,
    };
    // Guardian Information
    if (guardianInfo) {
      this.setState({
        guardianInformation: {
          guardianRelationship: guardianInfo.RelationType,
          guardianPrefix: guardianInfo.RelationPrefix,
          guardianFName: guardianInfo.RelationFirstName,
          guardianMName: guardianInfo.RelationMiddleName,
          guardianLName: guardianInfo.RelationLastName,
          guardianProfession: guardianInfo.Profession,
          guardianPhone: guardianInfo.MobileNumber,
          guardianEmail: guardianInfo.RelationEmail,
          guardianAddress: guardianInfo.GuardianAddress,
        },
      });
    }
    this.setState({ ai: data });
    this.setState({ fs: data1 });
    if (parseInt(data.selectedProgram) !== undergraduate) {
      this.setState({
        activeSections: [
          {
            name: "Applicant Personal Information",
            open: false,
          },
          {
            name: "Official Identification",
            open: false,
          },
          {
            name: "Education",
            open: false,
          },

          {
            name: "Program of Study",
            open: false,
          },
          {
            name: "Work Experience",
            open: false,
          },
          // {
          //   name: "Address",
          //   open: false,
          // },
          {
            name: "Applicant’s Contact Information",
            open: false,
          },
          // {
          //   name: 'Parents Information',
          //   open: false
          // },
          // {
          //   name: "Legal Guardian Information",
          //   open: false,
          // },

          {
            name: "English Proficiency Assessment",
            open: false,
          },
          // {
          //   name: "Health Information",
          //   open: false,
          // },
          {
            name: "Sources",
            open: false,
          },
          {
            name: "Funding Sources",
            open: false,
          },
          {
            name: "Policies",
            open: false,
          },
        ],
      });
    } else {
      this.setState({
        activeSections: Array.from(this.state.sections),
      });
    }
    // Parents Information
    if (fatherInfo && motherInfo) {
      this.setState({
        parentsInformation: {
          fatherPrefix: fatherInfo.RelationPrefix,
          motherPrefix: motherInfo.RelationPrefix,
          fatherRelation: fatherId,
          motherRelation: motherId,
          fatherFName: fatherInfo.RelationFirstName,
          motherFName: motherInfo.RelationFirstName,
          fatherMName: fatherInfo.RelationMiddleName,
          motherMName: motherInfo.RelationMiddleName,
          fatherLName: fatherInfo.RelationLastName,
          motherLName: motherInfo.RelationLastName,
          fatherProfession: fatherInfo.Profession,
          motherProfession: motherInfo.Profession,
          fatherCompany: fatherInfo.Company,
          motherCompany: motherInfo.Company,
          fatherCompanyAddress: fatherInfo.CompanyAddress,
          motherCompanyAddress: motherInfo.CompanyAddress,
          fatherPhone: fatherInfo.MobileNumber,
          motherPhone: motherInfo.MobileNumber,
          fatherEmail: fatherInfo.RelationEmail,
          motherEmail: motherInfo.RelationEmail,
          fatherAddress: fatherInfo.Address,
          motherAddress: motherInfo.Address,
          motherAttendedInstitution: motherInfo.AttendedInstitution,
          fatherAttendedInstitution: fatherInfo.AttendedInstitution,
          fatherDeceased: fatherInfo.Deceased,
          motherDeceased: motherInfo.Deceased,
        },
      });
    } else if (fatherInfo) {
      this.setState({
        parentsInformation: {
          fatherPrefix: fatherInfo.RelationPrefix || "",
          motherPrefix: "",
          fatherRelation: fatherId,
          motherRelation: motherId,
          fatherFName: fatherInfo.RelationFirstName || "",
          motherFName: "",
          fatherMName: fatherInfo.RelationMiddleName || "",
          motherMName: "",
          fatherLName: fatherInfo.RelationLastName || "",
          motherLName: "",
          fatherProfession: fatherInfo.Profession || "",
          motherProfession: "",
          fatherCompany: fatherInfo.Company || "",
          motherCompany: "",
          fatherCompanyAddress: fatherInfo.CompanyAddress || "",
          motherCompanyAddress: "",
          fatherPhone: fatherInfo.MobileNumber || "",
          motherPhone: "",
          fatherEmail: fatherInfo.RelationEmail || "",
          motherEmail: "",
          fatherAddress: fatherInfo.Address || "",
          motherAddress: "",
          motherAttendedInstitution: false,
          fatherAttendedInstitution: fatherInfo.AttendedInstitution || false,
          fatherDeceased: fatherInfo.Deceased,
          motherDeceased: "",
        },
      });
    } else if (motherInfo) {
      this.setState({
        parentsInformation: {
          fatherPrefix: "",
          motherPrefix: motherInfo.RelationPrefix,
          fatherRelation: fatherId,
          motherRelation: motherId,
          fatherFName: "",
          motherFName: motherInfo.RelationFirstName || "",
          fatherMName: "",
          motherMName: motherInfo.RelationMiddleName || "",
          fatherLName: "",
          motherLName: motherInfo.RelationLastName || "",
          fatherProfession: "",
          motherProfession: motherInfo.Profession || "",
          fatherCompany: "",
          motherCompany: motherInfo.Company || "",
          fatherCompanyAddress: "",
          motherCompanyAddress: motherInfo.CompanyAddress || "",
          fatherPhone: "",
          motherPhone: motherInfo.MobileNumber || "",
          fatherEmail: "",
          motherEmail: motherInfo.RelationEmail || "",
          fatherAddress: "",
          motherAddress: motherInfo.Address || "",
          motherAttendedInstitution: motherInfo.AttendedInstitution || false,
          fatherAttendedInstitution: false,
          fatherDeceased: "",
          motherDeceased: motherInfo.Deceased,
        },
      });
    }
    // Contact Information ALI
    if (contactInformation) {
      const newContactInfo = [];
      contactInformation.forEach((element, i) => {
        newContactInfo.push({
          phoneType: element.PhoneType,
          phoneCountry: element.CountryId,
          phoneNumber: element.PhoneNumber,
          isPrimary: element.IsPrimary,
          id: i,
        });
      });
      this.setState({
        contactInformations: {
          email: email,
          phoneNumberArray: newContactInfo,
        },
      });
    }
    // Test Scores
    if (testScoresProp && testScoresProp.length > 0) {
      const testScores = [];
      testScoresProp.forEach((element) => {
        testScores.push({
          test: element.Test,
          testType: element.TestType,
          score: element.Score,
          dateTaken: element.DateTaken,
        });
      });
      this.setState({
        testScores: { ...this.state.testScores, tests: testScores },
      });
    }

    if (workExperienceInfos) {
      this.setState({
        workExperienceInformation: {
          Company: workExperienceInfos.EmployerName,
          Position: workExperienceInfos.Position,
          StartDate: workExperienceInfos.StartDate,
          EndDate: workExperienceInfos.EndDate,
        },
      });
    } else {
      this.setState({ workExperienceInformation: {} });
    }

    // Education
    if (educationHistory && educationHistory.length === 1) {
      const data = [];
      const element = educationHistory[0];
      this.setState({
        educationHistorys: {
          underGradDegree: data,
          highSchoolCertificate: element.CurriculumId,
          endDate: element.EndDate,
          selectedCountry: element.CountryId,
          highSchoolName: element.InstitutionId,
          institutionName: element.InstitutionName,
          perviousUniversityName: element.TranferedInstitutionName,
          perviousUniversity: element.TranferedInstitutionId,
          previousUniversityCertificate: element.TransferredCerti,
          //previousUniversityMajor: element.TransferredMajor,
          previousUniversityGPA: element.TransferredGPA,
          educationGrade: element.EducationGrade,
          selectedCategory: element.selectedCategory,
        },
      });
    } else {
      this.setState({ educationHistorys: {} });
    }

    // Sources
    const newSources = [];
    if (sources) {
      sources.forEach((element) => {
        newSources.push(element.Id);
      });
      this.setState({
        sourceInformation: {
          selectedSources: newSources,
          otherSource: otherSource,
        },
      });
    }
  }

  personalInformationCheck(
    personalInformation = this.state.personalInformation
  ) {
    // const { personalInformation } = this.state;
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    const errorPI = {};
    if (
      personalInformation.fName &&
      personalInformation.lName &&
      personalInformation.mName &&
      personalInformation.selectedCountry &&
      personalInformation.selectedGender &&
      personalInformation.dateOfBirth &&
      (personalInformation.siblingTKHNumber.length === 0 ||
        personalInformation.siblingTKHNumber.length === 9) &&
      errorCheck.indexOf(personalInformation.selectedNationality) === -1 &&
      personalInformation.selectedNationality !== 50
    ) {
      //Sibling FN
      if (personalInformation.siblingFName) {
        if (!personalInformation.siblingLName) {
          errorPI.siblingLName = "Please Enter Last Name";
        }
        if (!personalInformation.siblingTKHNumber) {
          errorPI.siblingTKHNumber = "Please Enter ESLSCA Number";
        }

        if (!personalInformation.siblingFName) {
          errorPI.siblingFName = "Please Enter First Name";
        }

        if (!personalInformation.selectedCountry) {
          errorPI.selectedCountry = "Please Enter Country of Birth";
        }

        if (!personalInformation.dateOfBirth) {
          errorPI.dateOfBirth = "Please Enter Date Of Birth";
        }

        if (personalInformation.selectedNationality == 50) {
          if (!personalInformation.arabicText1) {
            errorPI.arabicText1 = "Please Enter Arabic First Name";
          }
          if (!personalInformation.arabicText2) {
            errorPI.arabicText2 = "Please Enter Arabic Middle Name";
          }
          if (!personalInformation.arabicText3) {
            errorPI.arabicText3 = "Please Enter Arabic Last Name";
          }

          if (
            !personalInformation.arabicText1 ||
            !personalInformation.arabicText2 ||
            !personalInformation.arabicText3
          ) {
            this.setState({ errorPI: errorPI });
            return 0;
          }

          if (
            personalInformation.arabicText1 &&
            personalInformation.arabicText2 &&
            personalInformation.arabicText3
          ) {
            this.setState({ errorPI: errorPI });
            return 1;
          }
        }

        if (
          personalInformation.siblingTKHNumber &&
          personalInformation.siblingLName
        ) {
          this.setState({ errorPI: {} });
          return 1;
        } else {
          if (!personalInformation.selectedCountry) {
            errorPI.selectedCountry = "Please Enter Nationality";
          }

          if (!personalInformation.dateOfBirth) {
            errorPI.dateOfBirth = "Please Enter Date Of Birth";
          }

          if (!personalInformation.countryOfBirth) {
            errorPI.countryOfBirth = "Please Enter Country Of Birth";
          }

          if (!personalInformation.selectedGender) {
            errorPI.selectedGender = "Please Enter Gender";
          }
        }

        this.setState({ errorPI: errorPI });
        return 0;
      }

      //Sibling TKH
      if (personalInformation.siblingTKHNumber) {
        if (!personalInformation.siblingLName) {
          errorPI.siblingLName = "Please Enter Last Name";
        }

        if (!personalInformation.siblingFName) {
          errorPI.siblingFName = "Please Enter First Name";
        }

        if (!personalInformation.selectedCountry) {
          errorPI.selectedCountry = "Please Enter Country of Birth";
        }

        if (!personalInformation.dateOfBirth) {
          errorPI.dateOfBirth = "Please Enter Date Of Birth";
        }

        if (personalInformation.selectedNationality == 50) {
          if (!personalInformation.arabicText1) {
            errorPI.arabicText1 = "Please Enter Arabic First Name";
          }
          if (!personalInformation.arabicText2) {
            errorPI.arabicText2 = "Please Enter Arabic Middle Name";
          }
          if (!personalInformation.arabicText3) {
            errorPI.arabicText3 = "Please Enter Arabic Last Name";
          }

          if (
            !personalInformation.arabicText1 ||
            !personalInformation.arabicText2 ||
            !personalInformation.arabicText3
          ) {
            this.setState({ errorPI: errorPI });
            return 0;
          }

          if (
            personalInformation.arabicText1 &&
            personalInformation.arabicText2 &&
            personalInformation.arabicText3
          ) {
            this.setState({ errorPI: errorPI });
            return 1;
          }
        }

        if (
          personalInformation.siblingLName &&
          personalInformation.SiblingFName
        ) {
          this.setState({ errorPI: {} });
          return 1;
        } else {
          if (!personalInformation.selectedCountry) {
            errorPI.selectedCountry = "Please Enter Nationality";
          }

          if (!personalInformation.dateOfBirth) {
            errorPI.dateOfBirth = "Please Enter Date Of Birth";
          }

          if (!personalInformation.countryOfBirth) {
            errorPI.countryOfBirth = "Please Enter Country Of Birth";
          }

          if (!personalInformation.selectedGender) {
            errorPI.selectedGender = "Please Enter Gender";
          }
        }

        this.setState({ errorPI: errorPI });
        return 0;
      }
      //Sibling LN
      if (personalInformation.siblingLName) {
        if (!personalInformation.siblingFName) {
          errorPI.siblingFName = "Please Enter First Name";
        }

        if (!personalInformation.siblingTKHNumber) {
          errorPI.siblingTKHNumber = "Please Enter ESLSCA Number";
        }

        if (!personalInformation.selectedCountry) {
          errorPI.selectedCountry = "Please Enter Country of Birth";
        }

        if (!personalInformation.dateOfBirth) {
          errorPI.dateOfBirth = "Please Enter Date Of Birth";
        }

        if (personalInformation.selectedNationality == 50) {
          if (!personalInformation.arabicText1) {
            errorPI.arabicText1 = "Please Enter Arabic First Name";
          }
          if (!personalInformation.arabicText2) {
            errorPI.arabicText2 = "Please Enter Arabic Middle Name";
          }
          if (!personalInformation.arabicText3) {
            errorPI.arabicText3 = "Please Enter Arabic Last Name";
          }

          if (
            !personalInformation.arabicText1 ||
            !personalInformation.arabicText2 ||
            !personalInformation.arabicText3
          ) {
            this.setState({ errorPI: errorPI });
            return 0;
          }

          if (
            personalInformation.arabicText1 &&
            personalInformation.arabicText2 &&
            personalInformation.arabicText3
          ) {
            this.setState({ errorPI: errorPI });
            return 1;
          }
        }

        if (
          personalInformation.siblingTKHNumber &&
          personalInformation.SiblingFName
        ) {
          this.setState({ errorPI: {} });
          return 1;
        } else {
          if (!personalInformation.selectedCountry) {
            errorPI.selectedCountry = "Please Enter Nationality";
          }

          if (!personalInformation.dateOfBirth) {
            errorPI.dateOfBirth = "Please Enter Date Of Birth";
          }

          if (!personalInformation.countryOfBirth) {
            errorPI.countryOfBirth = "Please Enter Country Of Birth";
          }

          if (!personalInformation.selectedGender) {
            errorPI.selectedGender = "Please Enter Gender";
          }
        }

        this.setState({ errorPI: errorPI });
        return 0;
      }

      if (personalInformation.selectedNationality == 50) {
        if (!personalInformation.arabicText1) {
          errorPI.arabicText1 = "Please Enter Arabic First Name";
        }
        if (!personalInformation.arabicText2) {
          errorPI.arabicText2 = "Please Enter Arabic Middle Name";
        }
        if (!personalInformation.arabicText3) {
          errorPI.arabicText3 = "Please Enter Arabic Last Name";
        }

        if (
          !personalInformation.arabicText1 ||
          !personalInformation.arabicText2 ||
          !personalInformation.arabicText3
        ) {
          this.setState({ errorPI: errorPI });
          return 0;
        }

        if (
          personalInformation.arabicText1 &&
          personalInformation.arabicText2 &&
          personalInformation.arabicText3
        ) {
          this.setState({ errorPI: errorPI });
          return 1;
        }
      }

      this.setState({ errorPI: {} });
      return 1;
    } else {
      const errorPI = {};
      if (!personalInformation.fName) {
        errorPI.fName = "Please Enter First Name";
      }
      if (!personalInformation.mName) {
        errorPI.mName = "Please Enter Middle Name";
      }
      if (!personalInformation.lName) {
        errorPI.lName = "Please Enter Last Name";
      }
      if (
        !(errorCheck.indexOf(personalInformation.selectedNationality) === -1)
      ) {
        errorPI.selectedNationality = "Please Select Nationality";
      }

      if (!personalInformation.selectedCountry) {
        errorPI.selectedCountry = "Please Enter Country of Birth";
      }
      if (!personalInformation.selectedGender) {
        errorPI.selectedGender = "Please Enter Gender";
      }

      if (!personalInformation.dateOfBirth) {
        errorPI.dateOfBirth = "Please Enter Date Of Birth";
      }

      if (personalInformation.siblingFName) {
        if (!personalInformation.siblingLName) {
          errorPI.siblingLName = "Please Enter Last Name";
        }
        if (!personalInformation.siblingTKHNumber) {
          errorPI.siblingTKHNumber = "Please Enter ESLSCA Number";
        }
      }

      if (personalInformation.SiblingTKHNumber) {
        if (!personalInformation.siblingLName) {
          errorPI.siblingLName = "Please Enter Fisrt Name";
        }
        if (!personalInformation.siblingFName) {
          errorPI.siblingFName = "Please Enter Last Name";
        }
      }

      if (personalInformation.siblingTKHNumber) {
        if (
          personalInformation.siblingTKHNumber.length > 0 &&
          personalInformation.siblingTKHNumber.length !== 9
        ) {
          errorPI.siblingTKHNumber = "Please Enter 9 characters";
        }
      }

      if (personalInformation.selectedNationality == 50) {
        if (!personalInformation.arabicText1) {
          errorPI.arabicText1 = "Please Enter Arabic First Name";
        }
        if (!personalInformation.arabicText2) {
          errorPI.arabicText2 = "Please Enter Arabic Middle Name";
        }
        if (!personalInformation.arabicText3) {
          errorPI.arabicText3 = "Please Enter Arabic Last Name";
        }

        if (
          personalInformation.arabicText1 &&
          personalInformation.arabicText2 &&
          personalInformation.arabicText3 &&
          personalInformation.mName
        ) {
          this.setState({ errorPI: errorPI });
          return 1;
        }
      }

      this.setState({ errorPI: errorPI });
      return 0;
    }
  }

  academicInterestCheck(ai = this.state.ai) {
    // Program of Study
    // const {
    //   ai
    // } = this.state
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    const errorAI = {};
    if (
      errorCheck.indexOf(ai.selectedMajor) ===
        -1 /*&& errorCheck.indexOf(ai.selectedLevel) === -1*/ &&
      errorCheck.indexOf(ai.selectedUniversity) === -1 &&
      errorCheck.indexOf(ai.selectedEntryTerm) === -1
    ) {
      if (
        errorCheck.indexOf(ai.selectedSecondUniversity) === -1 &&
        errorCheck.indexOf(ai.selectedSecondMajor) === -1
      ) {
        //MFChange
        /* if (!(errorCheck.indexOf(ai.selectedSecondLevel) === -1) || !(errorCheck.indexOf(ai.selectedLevel) === -1) ) { 

          errorAI.selectedSecondLevel = 'Please Select Level'
        //  this.setState({ errorAI: errorAI })
        
        if (!(errorCheck.indexOf(ai.selectedLevel) === -1)) 
          errorAI.selectedLevel = 'Please Select Level'

          this.setState({ errorAI: errorAI })
          return  0
        
        }*/
      }
      this.setState({ errorAI: {} });
      return 1;
    } else {
      // const errorAI = {}
      if (!(errorCheck.indexOf(ai.selectedUniversity) === -1)) {
        errorAI.selectedUniversity = "Please Select University";
      }

      if (!(errorCheck.indexOf(ai.selectedMajor) === -1)) {
        errorAI.selectedMajor = "Please Select Major";
      }

      if (!(errorCheck.indexOf(ai.selectedEntryTerm) === -1)) {
        errorAI.selectedEntryTerm = "Please Select Entry Term";
      }
      //MFChange
      /*if (!(errorCheck.indexOf(ai.selectedLevel) === -1)) {
        errorAI.selectedLevel = 'Please Select Level'
      }*/

      /*if ((errorCheck.indexOf(ai.selectedSecondUniversity) === -1) && (errorCheck.indexOf(ai.selectedSecondMajor) === -1) ) {
        if (!(errorCheck.indexOf(ai.selectedSecondLevel) === -1)) {
          errorAI.selectedSecondLevel = 'Please Select Level'
        }
      }*/

      this.setState({ errorAI: errorAI });

      return 0;
    }
  }

  governmentInformationCheck(
    governmentInformation = this.state.governmentInformation
  ) {
    // Governmnpment Information
    const { personalInformation } = this.state;
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    const errorGI = {};
    if (parseInt(personalInformation.selectedNationality) === 50) {
      if (governmentInformation.nationalNumber) {
        if (governmentInformation.nationalNumber.length === 14) {
          this.setState({ errorGI: {} });
          return 1;
        } else {
          errorGI.nationalNumber = "Please enter 14 numbers";
          this.setState({ errorGI: errorGI });
          return 0;
        }
      } else {
        if (!governmentInformation.nationalNumber) {
          errorGI.nationalNumber = "Please enter National ID Number";
        } else {
          if (governmentInformation.nationalNumber.length !== 14) {
            errorGI.nationalNumber = "Please enter 14 numbers";
          }
        }

        this.setState({ errorGI: errorGI });
        return 0;
      }
    } else {
      if (
        governmentInformation.passportNumber &&
        governmentInformation.passportExpiryDate &&
        errorCheck.indexOf(governmentInformation.passportCountry) === -1
      ) {
        this.setState({ errorGI: {} });
        return 1;
      } else {
        const errorGI = {};
        if (!governmentInformation.passportNumber) {
          errorGI.passportNumber = "Please Enter Passport Number";
        }

        if (!governmentInformation.passportExpiryDate) {
          errorGI.passportExpiryDate = "Please Enter Expiry Date";
        }

        if (
          !(errorCheck.indexOf(governmentInformation.passportCountry) === -1)
        ) {
          errorGI.passportCountry = "Please Select Country";
        }
        this.setState({ errorGI: errorGI });
        return 0;
      }
    }
  }

  workExperienceCheck(workExperience = this.state.workExperienceInformation) {
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    const errorWE = {};

    if (workExperience) {
      if (
        errorCheck.indexOf(workExperience.Company) === -1 &&
        errorCheck.indexOf(workExperience.Position) === -1 &&
        workExperience.StartDate &&
        workExperience.EndDate
      ) {
        this.setState({ errorWE: {} });
        return 1;
      } else {
        if (!(errorCheck.indexOf(workExperience.Company) === -1)) {
          errorWE.Company = "Please Select Company";
        }
        if (!(errorCheck.indexOf(workExperience.Position) === -1)) {
          errorWE.Position = "Please Select Position";
        }
        if (!workExperience.StartDate) {
          errorWE.StartDate = "Please Select Start Date";
        }
        if (!workExperience.EndDate) {
          errorWE.EndDate = "Please Select End Date";
        }
        this.setState({ errorWE: errorWE });
        return 0;
      }
    } else {
      errorWE.Company = "Please Select Company";
      errorWE.Position = "Please Select Position";
      errorWE.StartDate = "Please Select Start Date";
      errorWE.EndDate = "Please Select End Date";
      this.setState({ errorWE: errorWE });
      return 0;
    }
  }

  addressCheck(address = this.state.address) {
    // Address
    // const {
    //   address
    // } = this.state
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    if (
      errorCheck.indexOf(address.addressType) === -1 &&
      address.addressLine1 &&
      address.selectedCity &&
      errorCheck.indexOf(address.selectedCountry) === -1
    ) {
      this.setState({ errorAdd: {} });
      return 1;
    } else {
      const errorAdd = {};
      if (!(errorCheck.indexOf(address.addressType) === -1)) {
        errorAdd.addressType = "Please Select Address Type";
      }
      if (!address.addressLine1) {
        errorAdd.addressLine1 = "Please Enter Address Line 1";
      }

      if (!(errorCheck.indexOf(address.selectedCountry) === -1)) {
        errorAdd.selectedCountry = "Please Select Country";
      }

      if (!address.selectedCity) {
        errorAdd.selectedCity = "Please Enter City";
      }

      this.setState({ errorAdd: errorAdd });
      return 0;
    }
  }
  //ALI
  contactCheck(contactInformations = this.state.contactInformations) {
    // Contact Information
    // const {
    //   contactInformations
    // } = this.state
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    let countC = 0;
    const errorContact = {};
    if (
      contactInformations.phoneNumberArray &&
      contactInformations.phoneNumberArray.length >= 1
    ) {
      contactInformations.phoneNumberArray.forEach((element, index) => {
        errorContact[index] = {};
        if (
          errorCheck.indexOf(element.phoneNumber) !== -1 ||
          errorCheck.indexOf(element.phoneType) !== -1 ||
          errorCheck.indexOf(element.phoneCountry) !== -1
        ) {
          if (errorCheck.indexOf(element.phoneNumber) !== -1) {
            errorContact[index].phoneNumber = "Please Enter Number";
          }
          if (errorCheck.indexOf(element.phoneType) !== -1) {
            errorContact[index].phoneType = "Please Select Phone Type";
          }
          if (errorCheck.indexOf(element.phoneCountry) !== -1) {
            errorContact[index].phoneCountry = "Please Select Country";
          }
          countC = 1;
        }
      });
      if (countC === 0 && emailCheck.test(contactInformations.email)) {
        this.setState({ errorContact: {} });
        return 1;
      } else {
        this.setState({ errorContact: errorContact });
        return 0;
      }
    } else {
      errorContact[0] = {};
      errorContact[0].phoneNumber = "Please Enter Number";
      errorContact[0].phoneType = "Please Select Phone Type";
      errorContact[0].phoneCountry = "Please Select Country";
      this.setState({ errorContact: errorContact });
      return 0;
    }
  }

  parentsInformationCheck(parentsInformation = this.state.parentsInformation) {
    // // Parents Information
    // // const {
    // //   parentsInformation
    // // } = this.state
    // const errorCheck = [0, '', null, undefined, NaN, '0']
    // if (!parentsInformation.fatherDeceased && !parentsInformation.motherDeceased) {
    //   // check all fields
    //   if (errorCheck.indexOf(parentsInformation.fatherPrefix) === -1 && errorCheck.indexOf(parentsInformation.motherPrefix) === -1 && parentsInformation.fatherFName && parentsInformation.motherFName && parentsInformation.fatherMName && parentsInformation.motherMName && parentsInformation.fatherLName && parentsInformation.motherLName && parentsInformation.fatherProfession && parentsInformation.motherProfession && parentsInformation.fatherPhone && parentsInformation.motherPhone && parentsInformation.fatherEmail) {
    //     if ((emailCheck.test(parentsInformation.fatherEmail) || ['', null, undefined].indexOf(parentsInformation.fatherEmail) !== -1) &&
    //       (emailCheck.test(parentsInformation.motherEmail) || ['', null, undefined].indexOf(parentsInformation.motherEmail) !== -1)) {
    //       this.setState({ errorParent: {} })
    //       return 1
    //     } else {
    //       const errorParent = {}
    //       if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
    //         if (!emailCheck.test(parentsInformation.fatherEmail)) {
    //           errorParent.fatherEmail = 'Please Enter a Valid Email Address'
    //         }
    //       }
    //       if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
    //         if (!emailCheck.test(parentsInformation.motherEmail)) {
    //           errorParent.motherEmail = 'Please Enter a Valid Email Address'
    //         }
    //       }
    //       this.setState({ errorParent: errorParent })
    //       return 0
    //     }
    //   } else {
    //     const errorParent = {}
    //     if (!(errorCheck.indexOf(parentsInformation.fatherPrefix) === -1)) {
    //       errorParent.fatherPrefix = 'Please Select Prefix'
    //     }
    //     if (!parentsInformation.fatherFName) {
    //       errorParent.fatherFName = 'Please Enter First Name'
    //     }
    //     if (!parentsInformation.fatherMName) {
    //       errorParent.fatherMName = 'Please Enter Middle Name'
    //     }
    //     if (!parentsInformation.fatherLName) {
    //       errorParent.fatherLName = 'Please Enter Last Name'
    //     }
    //     if (!parentsInformation.fatherProfession) {
    //       errorParent.fatherProfession = 'Please Enter Profession'
    //     }
    //     if (!parentsInformation.fatherPhone) {
    //       errorParent.fatherPhone = 'Please Enter Number'
    //     }
    //     if (!parentsInformation.fatherEmail) {
    //       errorParent.fatherEmail = 'Please Enter Email Address'
    //     }
    //     if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
    //       if (!emailCheck.test(parentsInformation.fatherEmail)) {
    //         errorParent.fatherEmail = 'Please Enter a Valid Email Address'
    //       }
    //     }
    //     if (!(errorCheck.indexOf(parentsInformation.motherPrefix) === -1)) {
    //       errorParent.motherPrefix = 'Please Select Prefix'
    //     }
    //     if (!parentsInformation.motherFName) {
    //       errorParent.motherFName = 'Please Enter First Name'
    //     }
    //     if (!parentsInformation.motherMName) {
    //       errorParent.motherMName = 'Please Enter Middle Name'
    //     }
    //     if (!parentsInformation.motherLName) {
    //       errorParent.motherLName = 'Please Enter Last Name'
    //     }
    //     if (!parentsInformation.motherProfession) {
    //       errorParent.motherProfession = 'Please Enter Profession'
    //     }
    //     if (!parentsInformation.motherPhone) {
    //       errorParent.motherPhone = 'Please Enter Number'
    //     }
    //     if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
    //       if (!emailCheck.test(parentsInformation.motherEmail)) {
    //         errorParent.motherEmail = 'Please Enter a Valid Email Address'
    //       }
    //     }
    //     this.setState({ errorParent: errorParent })
    //     return 0
    //   }
    // } else if (parentsInformation.fatherDeceased && parentsInformation.motherDeceased) {
    //   if ((emailCheck.test(parentsInformation.motherEmail) || ['', null, undefined].indexOf(parentsInformation.motherEmail) !== -1) &&
    //     (emailCheck.test(parentsInformation.fatherEmail) || ['', null, undefined].indexOf(parentsInformation.fatherEmail) !== -1)) {
    //     this.setState({ errorParent: {} })
    //     return 1
    //   } else {
    //     const errorParent = {}
    //     if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
    //       if (!emailCheck.test(parentsInformation.motherEmail)) {
    //         errorParent.motherEmail = 'Please Enter a Valid Email Address'
    //       }
    //     }
    //     if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
    //       if (!emailCheck.test(parentsInformation.fatherEmail)) {
    //         errorParent.fatherEmail = 'Please Enter a Valid Email Address'
    //       }
    //     }
    //     this.setState({ errorParent: errorParent })
    //     return 0
    //   }
    // } else if (!parentsInformation.motherDeceased && parentsInformation.fatherDeceased) {
    //   // check father email and mother all fields
    //   if (errorCheck.indexOf(parentsInformation.motherPrefix) === -1 && parentsInformation.motherFName && parentsInformation.motherMName && parentsInformation.motherLName && parentsInformation.motherProfession && parentsInformation.motherPhone) {
    //     if ((emailCheck.test(parentsInformation.fatherEmail) || ['', null, undefined].indexOf(parentsInformation.fatherEmail) !== -1) &&
    //       (emailCheck.test(parentsInformation.motherEmail) || ['', null, undefined].indexOf(parentsInformation.motherEmail) !== -1)) {
    //       this.setState({ errorParent: {} })
    //       return 1
    //     } else {
    //       const errorParent = {}
    //       if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
    //         if (!emailCheck.test(parentsInformation.fatherEmail)) {
    //           errorParent.fatherEmail = 'Please Enter a Valid Email Address'
    //         }
    //       }
    //       if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
    //         if (!emailCheck.test(parentsInformation.motherEmail)) {
    //           errorParent.motherEmail = 'Please Enter a Valid Email Address'
    //         }
    //       }
    //       this.setState({ errorParent: errorParent })
    //       return 0
    //     }
    //   } else {
    //     const errorParent = {}
    //     if (!(errorCheck.indexOf(parentsInformation.motherPrefix) === -1)) {
    //       errorParent.motherPrefix = 'Please Select Prefix'
    //     }
    //     if (!parentsInformation.fatherEmail) {
    //       errorParent.fatherEmail = 'Please Enter Email Address'
    //     }
    //     if (!parentsInformation.motherFName) {
    //       errorParent.motherFName = 'Please Enter First Name'
    //     }
    //     if (!parentsInformation.motherMName) {
    //       errorParent.motherMName = 'Please Enter Middle Name'
    //     }
    //     if (!parentsInformation.motherLName) {
    //       errorParent.motherLName = 'Please Enter Last Name'
    //     }
    //     if (!parentsInformation.motherProfession) {
    //       errorParent.motherProfession = 'Please Enter Profession'
    //     }
    //     if (!parentsInformation.motherPhone) {
    //       errorParent.motherPhone = 'Please Enter Number'
    //     }
    //     if (!parentsInformation.fatherEmail) {
    //       errorParent.fatherEmail = 'Please Enter Email Address'
    //     }
    //     if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
    //       if (!emailCheck.test(parentsInformation.motherEmail)) {
    //         errorParent.motherEmail = 'Please Enter a Valid Email Address'
    //       }
    //     }
    //     if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
    //       if (!emailCheck.test(parentsInformation.fatherEmail)) {
    //         errorParent.fatherEmail = 'Please Enter a Valid Email Address'
    //       }
    //     }
    //     this.setState({ errorParent: errorParent })
    //     return 0
    //   }
    // } else if (!parentsInformation.fatherDeceased) {
    //   // check mother email and father all fields
    //   if (errorCheck.indexOf(parentsInformation.fatherPrefix) === -1 && parentsInformation.fatherFName && parentsInformation.fatherMName && parentsInformation.fatherLName && parentsInformation.fatherProfession && parentsInformation.fatherPhone) {
    //     if ((emailCheck.test(parentsInformation.motherEmail) || ['', null, undefined].indexOf(parentsInformation.motherEmail) !== -1) &&
    //       (emailCheck.test(parentsInformation.fatherEmail) || ['', null, undefined].indexOf(parentsInformation.fatherEmail) !== -1)) {
    //       this.setState({ errorParent: {} })
    //       return 1
    //     } else {
    //       const errorParent = {}
    //       if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
    //         if (!emailCheck.test(parentsInformation.motherEmail)) {
    //           errorParent.motherEmail = 'Please Enter a Valid Email Address'
    //         }
    //       }
    //       if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
    //         if (!emailCheck.test(parentsInformation.fatherEmail)) {
    //           errorParent.fatherEmail = 'Please Enter a Valid Email Address'
    //         }
    //       }
    //       this.setState({ errorParent: errorParent })
    //       return 0
    //     }
    //   } else {
    //     const errorParent = {}
    //     if (!(errorCheck.indexOf(parentsInformation.fatherPrefix) === -1)) {
    //       errorParent.fatherPrefix = 'Please Select Prefix'
    //     }
    //     if (!parentsInformation.fatherFName) {
    //       errorParent.fatherFName = 'Please Enter First Name'
    //     }
    //     if (!parentsInformation.fatherMName) {
    //       errorParent.fatherMName = 'Please Enter Middle Name'
    //     }
    //     if (!parentsInformation.fatherLName) {
    //       errorParent.fatherLName = 'Please Enter Last Name'
    //     }
    //     if (!parentsInformation.fatherProfession) {
    //       errorParent.fatherProfession = 'Please Enter Profession'
    //     }
    //     if (!parentsInformation.fatherPhone) {
    //       errorParent.fatherPhone = 'Please Enter Number'
    //     }
    //     if (!parentsInformation.fatherEmail) {
    //       errorParent.fatherEmail = 'Please Enter Email Address'
    //     }
    //     if (parentsInformation.fatherEmail) {
    //       if (!emailCheck.test(parentsInformation.fatherEmail)) {
    //         errorParent.fatherEmail = 'Please Enter a Valid Email Address'
    //       }
    //     }
    //     if (parentsInformation.motherEmail) {
    //       if (!emailCheck.test(parentsInformation.motherEmail)) {
    //         errorParent.motherEmail = 'Please Enter a Valid Email Address'
    //       }
    //     }
    //     this.setState({ errorParent: errorParent })
    //     return 0
    //   }
    // }
  }

  guardianInformationCheck(
    guardianInformation = this.state.guardianInformation
  ) {
    // Guardian Information
    // let isIdenticalPhoneNumber = false;
    // const { parentsInformation, fatherId, motherId } = this.state;
    // const errorCheck = [0, "", null, undefined, NaN, "0"];
    // if (
    //   ["", null, undefined].indexOf(parentsInformation.motherEmail) === -1 &&
    //   ["", null, undefined].indexOf(guardianInformation.guardianEmail) !== -1
    // ) {
    //   //if email address in the ParentMother's Info IS NOT NULL and NULL in the Guardian Info
    //   guardianInformation.guardianEmail = parentsInformation.motherEmail;
    // }
    // this.state.contactInformations.phoneNumberArray.forEach(
    //   (element, index) => {
    //     if (guardianInformation.guardianPhone === element.phoneNumber) {
    //       isIdenticalPhoneNumber = true;
    //     }
    //   }
    // );
    // if (
    //   errorCheck.indexOf(guardianInformation.guardianPrefix) === -1 &&
    //   guardianInformation.guardianFName &&
    //   guardianInformation.guardianEmail &&
    //   guardianInformation.guardianMName &&
    //   guardianInformation.guardianLName &&
    //   guardianInformation.guardianProfession &&
    //   guardianInformation.guardianPhone &&
    //   guardianInformation.guardianAddress &&
    //   guardianInformation.guardianRelationship !== "" &&
    //   isIdenticalPhoneNumber === false
    // ) {
    /* if ([fatherId].indexOf(parseInt(guardianInformation.guardianRelationship)) !== -1) {
        if (parentsInformation.fatherDeceased !== false) {
          this.setState({ errorGuard: { guardianRelationship: 'A deceased person cannot be a guardian' } })
          return 0
        } else 
        {
            this.setState({ errorGuard: {} })
            return 1
        
        }
      } else if ([motherId].indexOf(parseInt(guardianInformation.guardianRelationship)) !== -1) {
        if (parentsInformation.motherDeceased !== false) {
          this.setState({ errorGuard: { guardianRelationship: 'A deceased person cannot be a guardian' } })
          return 0
        } else {
          if (['', null, undefined].indexOf(guardianInformation.guardianEmail) === -1) {
            if (emailCheck.test(guardianInformation.guardianEmail)) {
              if(guardianInformation.guardianEmail===this.state.contactInformations.email)
              {
                this.setState({ errorGuard: { guardianEmail: 'Please Enter a Different Email Address' } })
                return 0
              }else{
              this.setState({ errorGuard: {} })
              }
            } else {
              this.setState({ errorGuard: { guardianEmail: 'Please Enter a Valid Email Address' } })
              return 0
            }
          } else {
            this.setState({ errorGuard: {} })
            return 1
          }
        }
      } else {*/
    //   if (
    //     ["", null, undefined].indexOf(guardianInformation.guardianEmail) === -1
    //   ) {
    //     if (emailCheck.test(guardianInformation.guardianEmail)) {
    //       if (
    //         guardianInformation.guardianEmail ===
    //         this.state.contactInformations.email
    //       ) {
    //         this.setState({
    //           errorGuard: {
    //             guardianEmail: "Please Enter a Different Email Address",
    //           },
    //         });
    //         return 0;
    //       } else {
    //         this.setState({ errorGuard: {} });
    //         return 1;
    //       }
    //     } else {
    //       this.setState({
    //         errorGuard: { guardianEmail: "Please Enter a Valid Email Address" },
    //       });
    //       return 0;
    //     }
    //   } else {
    //     this.setState({ errorGuard: {} });
    //     return 1;
    //   }
    //   //}
    // } else {
    //   const errorGuard = {};
    //   if (!(errorCheck.indexOf(guardianInformation.guardianPrefix) === -1)) {
    //     errorGuard.guardianPrefix = "Please Select Prefix";
    //   }
    //   if (!guardianInformation.guardianEmail) {
    //     errorGuard.guardianEmail = "Please Enter Email Address";
    //   }
    //   if (!guardianInformation.guardianFName) {
    //     errorGuard.guardianFName = "Please Enter First Name";
    //   }
    //   if (!guardianInformation.guardianMName) {
    //     errorGuard.guardianMName = "Please Enter Middle Name";
    //   }
    //   if (!guardianInformation.guardianLName) {
    //     errorGuard.guardianLName = "Please Enter Last Name";
    //   }
    //   if (!guardianInformation.guardianProfession) {
    //     errorGuard.guardianProfession = "Please Enter Profession";
    //   }
    //   if (!guardianInformation.guardianPhone) {
    //     errorGuard.guardianPhone = "Please Enter Number";
    //   } else if (isIdenticalPhoneNumber === true) {
    //     errorGuard.guardianPhone = "Please Enter A Different Phone Number";
    //   }
    //   if (guardianInformation.guardianEmail) {
    //     if (!emailCheck.test(guardianInformation.guardianEmail)) {
    //       errorGuard.guardianEmail = "Please Enter a Valid Email Address";
    //     }
    //   }
    //   if (
    //     !(errorCheck.indexOf(guardianInformation.guardianRelationship) === -1)
    //   ) {
    //     errorGuard.guardianRelationship = "Please Select Relationship";
    //   }
    //   if (!(errorCheck.indexOf(guardianInformation.guardianAddress) === -1)) {
    //     errorGuard.guardianAddress = "Please Enter Mailing Address";
    //   }
    //   this.setState({ errorGuard: errorGuard });
    //   return 0;
    // }
  }

  educationHistoryCheck(educationHistorys = this.state.educationHistorys) {
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    const errorEdu = {};
    // Check highSchoolName
    if (
      errorCheck.indexOf(educationHistorys.highSchoolName) !== -1 &&
      errorCheck.indexOf(educationHistorys.institutionName) !== -1
    ) {
      errorEdu.highSchoolName = "Please Select University";
    }
    // Check highSchoolCertificate
    if (errorCheck.indexOf(educationHistorys.highSchoolCertificate) !== -1) {
      errorEdu.highSchoolCertificate = "Please Select Major";
    }
    // Check educationGrade
    if (errorCheck.indexOf(educationHistorys.educationGrade) !== -1) {
      errorEdu.educationGrade = "Please Enter Grade";
    }
    // If there are no errors, clear error state and return 1
    if (Object.keys(errorEdu).length === 0) {
      this.setState({ errorEdu: {} });
      return 1;
    } else {
      // Otherwise, set the error state and return 0
      this.setState({ errorEdu: errorEdu });
      return 0;
    }
  }

  testScoresCheck(testScores = this.state.testScores) {
    const errorCheck = [0, "", null, undefined, NaN, "0"];
    if (testScores.tests && testScores.tests.length > 0) {
      const testArray = testScores.tests;
      let count = 1;
      const errorTest = [];
      testArray.forEach((element, index) => {
        errorTest[index] = {};
        if (
          errorCheck.indexOf(element.test) !== -1 &&
          errorCheck.indexOf(element.testType) !== -1 &&
          errorCheck.indexOf(element.dateTaken) !== -1 &&
          errorCheck.indexOf(element.score) !== -1
        ) {
          errorTest[index] = {};
        } else if (
          errorCheck.indexOf(element.test) !== -1 ||
          errorCheck.indexOf(element.testType) !== -1 ||
          errorCheck.indexOf(element.dateTaken) !== -1 ||
          errorCheck.indexOf(element.score) !== -1
        ) {
          count = 0;
          if (errorCheck.indexOf(element.test) !== -1) {
            errorTest[index].test = "Please select test";
          }
          if (errorCheck.indexOf(element.testType) !== -1) {
            errorTest[index].testType = "Please select test type";
          }
          if (errorCheck.indexOf(element.score) !== -1) {
            errorTest[index].score = "Please enter score";
          }
          if (errorCheck.indexOf(element.dateTaken) !== -1) {
            errorTest[index].dateTaken = "Please enter date taken";
          }
        }
      });

      //this test is for the Section Englist to light the section in red if not all the conditions is valid
      if (
        this.state.policyError.includes("English Proficiency Assessment") ||
        this.state.policyError.includes(
          "Please enter all test type for the choosen test(s)"
        )
      ) {
        this.setState({ errorTest: errorTest });
        this.setState({ policyError: "" });
        return 0;
      }
      if (count === 1) {
        this.setState({ errorTest: [] });
        return 1;
      } else {
        this.setState({ errorTest: errorTest });
        return 0;
      }
    } else {
      this.setState({ errorTest: [] });
      return 1;
    }
  }

  healthInformationCheck(healthInformation = this.state.healthInformation) {
    // Health Information
    // const {
    //   healthInformation
    // } = this.state
    // if (
    //   (healthInformation.hasIllness ||
    //     healthInformation.hasIllness === "True") &&
    //   healthInformation.illness
    // ) {
    //   this.setState({ errorHI: {} });
    //   return 1;
    // } else if (
    //   !healthInformation.hasIllness ||
    //   healthInformation.hasIllness === "False"
    // ) {
    //   this.setState({ errorHI: {} });
    //   return 1;
    // } else {
    //   this.setState({
    //     errorHI: { illness: "Please fill required information" },
    //   });
    //   return 0;
    // }
  }

  sourcesCheck(sourceInformation = this.state.sourceInformation) {
    // Sources
    // const {
    //   sourceInformation
    // } = this.state
    const error = [];
    if (
      sourceInformation.selectedSources &&
      sourceInformation.selectedSources.length >= 1
    ) {
      if (
        sourceInformation.selectedSources.includes(16) &&
        !sourceInformation.otherSource
      ) {
        this.setState({
          errorSources: { general: "Please Specify the other value." },
        });
        return 0;
      } else {
        this.setState({ errorSources: {} });
        return 1;
      }
    } else {
      this.setState({
        errorSources: { general: "Please Select at-least one." },
      });
      return 0;
    }
  }

  conditionCheck() {
    const count = [0, 0, 0, 0, 0, 0, 0, 0];

    // Personal Information
    count[0] = this.personalInformationCheck();
    // Government Information
    count[1] = this.governmentInformationCheck();
    // Education
    count[2] = this.educationHistoryCheck();
    // Program of Study
    count[3] = this.academicInterestCheck();
    // Work Experience
    count[4] = this.workExperienceCheck();
    // Address
    // count[5] = this.addressCheck();
    // Contact Information
    count[5] = this.contactCheck();
    // Parents Information
    //count[6] = this.parentsInformationCheck()
    // Guardian Information
    // count[7] = this.guardianInformationCheck();
    // Test Scores
    count[6] = this.testScoresCheck();
    // Health Information
    // count[9] = this.healthInformationCheck();
    // Sources
    count[7] = this.sourcesCheck();

    this.setState({ count: count });
    //console.log(count);
    return count;
  }

  getActiveTabBody(i) {
    const {
      healthInformation,
      sourceInformation,
      acceptedPolicies,
      countryData,
      dateOfBirth,
      countryOfBirth,
      nationality,
      gender,
      arabicData,
      incompleteApplicationId,
      fName,
      lName,
      mName,
      siblingFName,
      siblingMName,
      siblingLName,
      siblingTKHNumber,
      selectedSecondUniversity,
      selectedSecondMajor,
      selectedLevel,
      selectedSecondLevel,
      selectedSecondProgram,

      selectedProgram,
      selectedMajor,
      entryTerm,
      selectedUniversity,
      selectedSchedule,

      description,
      secondDescription,
      nationalIdNumber,
      passportNumber,
      passportCountry,
      passportExpiry,
      addressType,
      line1,
      line2,
      country,
      city,
      contactInformation,
      email,
      fatherInfo,
      motherInfo,
      guardianInfo,
      educationHistory,
      hasBeenIll,
      illnessDescription,
      errorPI,
      errorAI,
      errorGI,
      workExperienceInfos,
      errorWE,
      errorAdd,
      errorContact,
      errorParent,
      errorGuard,
      errorEdu,
      errorHI,
      errorSources,
      ai,
      fs,
      personalInformation,
      parentsInformation,
      undergraduate,
      fatherId,
      motherId,
      otherSource,
      testScores,
      errorTest,
      selectedLanguage,
      selectedFundingSource,
    } = this.state;
    let returnValue = "";
    const selectedSources = [];
    if (
      sourceInformation.selectedSources &&
      sourceInformation.selectedSources.length > 0
    ) {
      sourceInformation.selectedSources.forEach((element) => {
        selectedSources.push({
          Id: element,
        });
      });
    }

    if (
      ai.selectedProgram &&
      (parseInt(ai.selectedProgram) === undergraduate ||
        ai.selectedProgram === "")
    ) {
      switch (i) {
        case 0:
          returnValue = (
            <PersonalInformation
              countryData={countryData || 0}
              dateOfBirth={dateOfBirth || ""}
              countryOfBirth={countryOfBirth || 0}
              nationality={nationality || 0}
              gender={gender || ""}
              arabicData={arabicData || []}
              siblingFName={siblingFName || ""}
              siblingMName={siblingMName || ""}
              siblingLName={siblingLName || ""}
              siblingTKHNumber={siblingTKHNumber || ""}
              incompleteApplicationId={incompleteApplicationId}
              error={errorPI}
              onSave={() => this.toggleAccordion(0)}
              fName={fName}
              lName={lName}
              mName={mName}
              collectState={this.collectState}
            />
          );
          break;
        case 1:
          const userNationality =
            parseInt(personalInformation.selectedNationality) || nationality;
          if (
            userNationality !== 0 &&
            userNationality !== "" &&
            userNationality !== "0"
          ) {
            returnValue = (
              <GovernmentInformation
                incompleteApplicationId={incompleteApplicationId}
                countryData={countryData}
                nationality={userNationality}
                nationalIdNumber={nationalIdNumber || ""}
                passportNumber={passportNumber || ""}
                passportCountry={passportCountry || ""}
                passportExpiry={passportExpiry || ""}
                onSave={() => this.toggleAccordion(1)}
                collectState={this.collectState}
                error={errorGI}
              />
            );
          } else {
            returnValue = (
              <div>
                Please fill the Applicant Personal Information section first
              </div>
            );
          }
          break;
        case 2:
          const userSelectedProgram =
            parseInt(ai.selectedProgram) || parseInt(selectedProgram);
          if (
            [undergraduate, "", null, undefined, 0].indexOf(
              parseInt(userSelectedProgram)
            ) === -1 &&
            !isNaN(userSelectedProgram)
          ) {
            returnValue = (
              <EducationHistoryUndergraduate
                incompleteApplicationId={incompleteApplicationId}
                onSave={() => this.toggleAccordion(2)}
                countryData={countryData}
                educationHistory={educationHistory || []}
                program={parseInt(selectedProgram)}
                collectState={this.collectState}
                error={errorEdu}
              />
            );
          } else {
            returnValue = (
              <EducationHistoryUndergraduate
                incompleteApplicationId={incompleteApplicationId}
                onSave={() => this.toggleAccordion(2)}
                countryData={countryData}
                educationHistory={educationHistory || []}
                program={parseInt(selectedProgram)}
                collectState={this.collectState}
                error={errorEdu}
              />
            );
          }
          break;
        case 3:
          returnValue = (
            <AcademicInterest
              selectedSecondUniversity={selectedSecondUniversity || ""}
              selectedSecondMajor={selectedSecondMajor || ""}
              selectedLevel={selectedLevel || ""}
              selectedSecondLevel={selectedSecondLevel || ""}
              selectedSecondProgram={selectedSecondProgram || ""}
              incompleteApplicationId={incompleteApplicationId}
              selectedProgram={selectedProgram || ""}
              selectedMajor={selectedMajor || ""}
              entryTerm={entryTerm || ""}
              selectedUniversity={selectedUniversity || ""}
              selectedSchedule={selectedSchedule || ""}
              description={description || ""}
              secondDescription={secondDescription || ""}
              selectedLanguage={selectedLanguage || ""}
              onSave={() => this.toggleAccordion(3)}
              collectState={this.collectState}
              error={errorAI}
            />
          );
          break;

        case 4:
          returnValue = (
            <WorkExperience
              workExperienceInfos={workExperienceInfos || []}
              incompleteApplicationId={incompleteApplicationId}
              onSave={() => this.toggleAccordion(4)}
              collectState={this.collectState}
              getDefaultValue={this.getDefaultValue}
              error={errorWE}
            />
          );
          break;
        // case 5:
        //   returnValue = (
        //     <Address
        //       addressType={addressType}
        //       line1={line1}
        //       line2={line2}
        //       country={country}
        //       city={city}
        //       incompleteApplicationId={incompleteApplicationId}
        //       countryData={countryData}
        //       onSave={() => this.toggleAccordion(5)}
        //       collectState={this.collectState}
        //       getDefaultValue={this.getDefaultValue}
        //       error={errorAdd}
        //     />
        //   );
        //   break;
        case 5:
          returnValue = (
            <Contact
              contactInformation={contactInformation || []}
              incompleteApplicationId={incompleteApplicationId}
              countryData={countryData}
              onSave={() => this.toggleAccordion(5)}
              collectState={this.collectState}
              error={errorContact}
              email={email}
              getDefaultValue={this.getDefaultValue}
            />
          );
          break;
        /*case 6:
          returnValue = <ParentsInformation
            fatherInfo={fatherInfo || {}}
            motherInfo={motherInfo || {}}
            fatherId={fatherId}
            motherId={motherId}
            incompleteApplicationId={incompleteApplicationId}
            onSave={(motherInfo, fatherInfo) => {
              this.setState({
                motherInfo: motherInfo,
                fatherInfo: fatherInfo
              })
              this.toggleAccordion(7)
            }}
            error={errorParent}
            collectState={this.collectState}
            getDefaultValue={this.getDefaultValue}

          />
          break*/
        // case 7:
        //   const fatherInfos = {
        //     RelationFirstName: parentsInformation.fatherFName,
        //     RelationMiddleName: parentsInformation.fatherMName,
        //     RelationLastName: parentsInformation.fatherLName,
        //     RelationPrefix: parentsInformation.fatherPrefix,
        //     RelationType: fatherId,
        //     Profession: parentsInformation.fatherProfession,
        //     Company: parentsInformation.fatherCompany,
        //     CompanyAddress: parentsInformation.fatherCompanyAddress,
        //     MobileNumber: parentsInformation.fatherPhone,
        //     RelationEmail: parentsInformation.fatherEmail,
        //     Address: parentsInformation.fatherAddress,
        //   };
        //   const motherInfos = {
        //     RelationFirstName: parentsInformation.motherFName,
        //     RelationMiddleName: parentsInformation.motherMName,
        //     RelationLastName: parentsInformation.motherLName,
        //     RelationPrefix: parentsInformation.motherPrefix,
        //     RelationType: motherId,
        //     Profession: parentsInformation.motherProfession,
        //     Company: parentsInformation.motherCompany,
        //     CompanyAddress: parentsInformation.motherCompanyAddress,
        //     MobileNumber: parentsInformation.motherPhone,
        //     RelationEmail: parentsInformation.motherEmail,
        //     Address: parentsInformation.motherAddress,
        //   };
        //   returnValue = (
        //     <GuardianInformation
        //       incompleteApplicationId={incompleteApplicationId}
        //       motherInfo={motherInfos || motherInfo || {}}
        //       fatherInfo={fatherInfos || fatherInfo || {}}
        //       guardianInfo={guardianInfo || {}}
        //       motherId={motherId}
        //       fatherId={fatherId}
        //       onSave={() => this.toggleAccordion(7)}
        //       error={errorGuard}
        //       collectState={this.collectState}
        //     />
        //   );
        //   break;

        case 6:
          returnValue = (
            <TestScores
              collectState={this.collectState}
              testScore={testScores}
              error={errorTest}
              onSave={() => this.toggleAccordion(6)}
            />
          );
          break;

        // case 9:
        //   returnValue = (
        //     <HealthInformation
        //       incompleteApplicationId={incompleteApplicationId}
        //       hasBeenIll={healthInformation.hasIllness || hasBeenIll || false}
        //       illnessDescription={
        //         healthInformation.illness || illnessDescription || ""
        //       }
        //       collectState={this.collectState}
        //       error={errorHI}
        //       onSave={() => this.toggleAccordion(9)}
        //     />
        //   );
        //   break;
        case 7:
          returnValue = (
            <Sources
              incompleteApplicationId={incompleteApplicationId}
              sources={selectedSources || []}
              otherSource={otherSource || null}
              collectState={this.collectState}
              error={errorSources}
              onSave={() => this.toggleAccordion(7)}
            />
          );
          break;
        case 8:
          returnValue = (
            <FundingSource
              selectedFundingSource={selectedFundingSource}
              incompleteApplicationId={incompleteApplicationId}
              onSave={() => this.toggleAccordion(8)}
              collectState={this.collectState}
              getDefaultValue={this.getDefaultValue}
              // error={errorWE}
            />
          );
          break;
        case 9:
          returnValue = (
            <Policies
              incompleteApplicationId={incompleteApplicationId}
              acceptedPolicies={acceptedPolicies}
              collectState={this.collectState}
            />
          );
          break;
        default:
          returnValue = <p>Work in Progress</p>;
          break;
      }
    } else {
      switch (i) {
        case 0:
          returnValue = (
            <PersonalInformation
              countryData={countryData || 0}
              dateOfBirth={dateOfBirth || ""}
              countryOfBirth={countryOfBirth || 0}
              nationality={nationality || 0}
              gender={gender || ""}
              arabicData={arabicData || []}
              siblingFName={siblingFName || ""}
              siblingMName={siblingMName || ""}
              siblingLName={siblingLName || ""}
              siblingTKHNumber={siblingTKHNumber || ""}
              incompleteApplicationId={incompleteApplicationId}
              fName={fName}
              lName={lName}
              mName={mName}
              onSave={() => this.toggleAccordion(0)}
              collectState={this.collectState}
              error={errorPI}
            />
          );
          break;
        case 1:
          const userNationality =
            parseInt(personalInformation.selectedNationality) || nationality;
          if (
            userNationality !== 0 &&
            userNationality !== "" &&
            userNationality !== "0"
          ) {
            returnValue = (
              <GovernmentInformation
                incompleteApplicationId={incompleteApplicationId}
                countryData={countryData}
                nationality={userNationality}
                nationalIdNumber={nationalIdNumber || ""}
                passportNumber={passportNumber || ""}
                passportCountry={passportCountry || ""}
                passportExpiry={passportExpiry || ""}
                onSave={() => this.toggleAccordion(1)}
                collectState={this.collectState}
                error={errorGI}
              />
            );
          } else {
            returnValue = (
              <div>
                Please fill the Applicant Personal Information section first
              </div>
            );
          }

          break;
        case 2:
          const userSelectedProgram =
            parseInt(ai.selectedProgram) || parseInt(selectedProgram);
          if (
            [undergraduate, "", null, undefined, 0].indexOf(
              parseInt(userSelectedProgram)
            ) === -1 &&
            !isNaN(userSelectedProgram)
          ) {
            returnValue = (
              <EducationHistoryUndergraduate
                incompleteApplicationId={incompleteApplicationId}
                onSave={() => this.toggleAccordion(2)}
                countryData={countryData}
                educationHistory={educationHistory || []}
                program={parseInt(selectedProgram)}
                collectState={this.collectState}
                error={errorEdu}
              />
            );
          } else {
            returnValue = (
              <EducationHistoryUndergraduate
                incompleteApplicationId={incompleteApplicationId}
                onSave={() => this.toggleAccordion(2)}
                countryData={countryData}
                educationHistory={educationHistory || []}
                program={parseInt(selectedProgram)}
                collectState={this.collectState}
                error={errorEdu}
              />
            );
          }
          break;
        case 3:
          returnValue = (
            <AcademicInterest
              selectedSecondUniversity={selectedSecondUniversity || ""}
              selectedSecondMajor={selectedSecondMajor || ""}
              selectedLevel={selectedLevel || ""}
              selectedSecondLevel={selectedSecondLevel || ""}
              selectedSecondProgram={selectedSecondProgram || ""}
              incompleteApplicationId={incompleteApplicationId}
              selectedProgram={selectedProgram || ""}
              selectedMajor={selectedMajor || ""}
              entryTerm={entryTerm || ""}
              selectedUniversity={selectedUniversity || ""}
              selectedSchedule={selectedSchedule || ""}
              description={description || ""}
              secondDescription={secondDescription || ""}
              selectedLanguage={selectedLanguage || ""}
              onSave={() => this.toggleAccordion(3)}
              collectState={this.collectState}
              error={errorAI}
            />
          );
          break;

        case 4:
          returnValue = (
            <WorkExperience
              workExperienceInfos={workExperienceInfos || []}
              incompleteApplicationId={incompleteApplicationId}
              onSave={() => this.toggleAccordion(4)}
              collectState={this.collectState}
              getDefaultValue={this.getDefaultValue}
              error={errorWE}
            />
          );
          break;
        // case 5:
        //   returnValue = (
        //     <Address
        //       addressType={addressType}
        //       line1={line1}
        //       line2={line2}
        //       country={country}
        //       city={city}
        //       incompleteApplicationId={incompleteApplicationId}
        //       countryData={countryData}
        //       onSave={() => this.toggleAccordion(5)}
        //       collectState={this.collectState}
        //       getDefaultValue={this.getDefaultValue}
        //       error={errorAdd}
        //     />
        //   );
        //   break;
        case 5:
          returnValue = (
            <Contact
              contactInformation={contactInformation || []}
              incompleteApplicationId={incompleteApplicationId}
              countryData={countryData}
              onSave={() => this.toggleAccordion(5)}
              collectState={this.collectState}
              error={errorContact}
              email={email}
              getDefaultValue={this.getDefaultValue}
            />
          );
          break;
        /*case 6:
          returnValue = <ParentsInformation
            fatherInfo={fatherInfo || {}}
            motherInfo={motherInfo || {}}
            fatherId={fatherId}
            motherId={motherId}
            incompleteApplicationId={incompleteApplicationId}
            onSave={(motherInfo, fatherInfo) => {
              this.setState({
                motherInfo: motherInfo,
                fatherInfo: fatherInfo
              })
              this.toggleAccordion(7)
            }}
            error={errorParent}
            collectState={this.collectState}
            getDefaultValue={this.getDefaultValue}

          />
          break*/
        // case 7:
        //   const fatherInfos = {
        //     RelationFirstName: parentsInformation.fatherFName,
        //     RelationMiddleName: parentsInformation.fatherMName,
        //     RelationLastName: parentsInformation.fatherLName,
        //     RelationPrefix: parentsInformation.fatherPrefix,
        //     RelationType: fatherId,
        //     Profession: parentsInformation.fatherProfession,
        //     Company: parentsInformation.fatherCompany,
        //     CompanyAddress: parentsInformation.fatherCompanyAddress,
        //     MobileNumber: parentsInformation.fatherPhone,
        //     RelationEmail: parentsInformation.fatherEmail,
        //     Address: parentsInformation.fatherAddress,
        //   };
        //   const motherInfos = {
        //     RelationFirstName: parentsInformation.motherFName,
        //     RelationMiddleName: parentsInformation.motherMName,
        //     RelationLastName: parentsInformation.motherLName,
        //     RelationPrefix: parentsInformation.motherPrefix,
        //     RelationType: motherId,
        //     Profession: parentsInformation.motherProfession,
        //     Company: parentsInformation.motherCompany,
        //     CompanyAddress: parentsInformation.motherCompanyAddress,
        //     MobileNumber: parentsInformation.motherPhone,
        //     RelationEmail: parentsInformation.motherEmail,
        //     Address: parentsInformation.motherAddress,
        //   };
        //   returnValue = (
        //     <GuardianInformation
        //       incompleteApplicationId={incompleteApplicationId}
        //       motherInfo={motherInfos || motherInfo || {}}
        //       fatherInfo={fatherInfos || fatherInfo || {}}
        //       guardianInfo={guardianInfo || {}}
        //       motherId={motherId}
        //       fatherId={fatherId}
        //       onSave={() => this.toggleAccordion(8)}
        //       error={errorGuard}
        //       collectState={this.collectState}
        //     />
        // );
        // break;

        case 6:
          returnValue = (
            <TestScores
              collectState={this.collectState}
              testScore={testScores}
              error={errorTest}
              onSave={() => this.toggleAccordion(6)}
            />
          );
          break;
        // case 9:
        //   returnValue = (
        //     <HealthInformation
        //       incompleteApplicationId={incompleteApplicationId}
        //       hasBeenIll={healthInformation.hasIllness || hasBeenIll || false}
        //       illnessDescription={
        //         healthInformation.illness || illnessDescription || ""
        //       }
        //       collectState={this.collectState}
        //       error={errorHI}
        //       onSave={() => this.toggleAccordion(10)}
        //     />
        //   );
        //   break;
        case 7:
          returnValue = (
            <Sources
              incompleteApplicationId={incompleteApplicationId}
              sources={selectedSources || []}
              collectState={this.collectState}
              error={errorSources}
              otherSource={otherSource || null}
              onSave={() => this.toggleAccordion(7)}
            />
          );
          break;
        case 8:
          returnValue = (
            <FundingSource
              selectedFundingSource={selectedFundingSource}
              incompleteApplicationId={incompleteApplicationId}
              onSave={() => this.toggleAccordion(8)}
              collectState={this.collectState}
              getDefaultValue={this.getDefaultValue}
              // error={errorWE}
            />
          );
          break;
        case 9:
          returnValue = (
            <Policies
              incompleteApplicationId={incompleteApplicationId}
              acceptedPolicies={acceptedPolicies}
              collectState={this.collectState}
            />
          );
          break;
        default:
          returnValue = <p>Work in Progress</p>;
          break;
      }
    }
    return <div className="accordionSectionBody">{returnValue}</div>;
  }

  collectState(componentName, data) {
    switch (componentName) {
      case "FS":
        this.setState({ fs: data });
        break;

      case "PI":
        this.setState({ personalInformation: data });
        const { errorPI } = this.state;
        const errorPIKeys = Object.keys(errorPI);
        if (errorPIKeys.length) {
          const returnValue = this.personalInformationCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[0] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "GI":
        this.setState({ governmentInformation: data });
        const { errorGI } = this.state;
        const errorGIKeys = Object.keys(errorGI);
        if (errorGIKeys.length) {
          const returnValue = this.governmentInformationCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[1] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "EH":
        this.setState({ educationHistorys: data });
        const { errorEdu } = this.state;
        const errorEduKeys = Object.keys(errorEdu);
        if (errorEduKeys.length) {
          const returnValue = this.educationHistoryCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[2] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "WE":
        this.setState({ workExperienceInformation: data });
        const { errorWE } = this.state;
        const errorWEKeys = Object.keys(errorWE);
        if (errorWEKeys.length) {
          const returnValue = this.workExperienceCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[4] = 1;
            this.setState({ count: count });
          }
        }
        break;

      case "AI":
        const accordionValue = this.state.activeSections[3].open;
        // if (data.selectedProgram + "" !== this.state.ai.selectedProgram + "") {
        //   this.setState({
        //     educationHistory: [],
        //     educationHistorys: {},
        //     errorEdu: {},
        //     selectedProgram: data.selectedProgram,
        //   });
        // }
        this.setState({ ai: data });
        const { errorAI } = this.state;
        const errorAIKeys = Object.keys(errorAI);
        if (errorAIKeys.length) {
          const returnValue = this.academicInterestCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[3] = 1;
            this.setState({ count: count });
          }
        }
        if (parseInt(data.selectedProgram) !== this.state.undergraduate) {
          this.setState({
            activeSections: [
              {
                name: "Applicant Personal Information",
                open: false,
              },
              {
                name: "Official Identification",
                open: false,
              },
              {
                name: "Education",
                open: false,
              },
              {
                name: "Program of Study",
                open: accordionValue,
              },
              {
                name: "Work Experience",
                open: false,
              },
              // {
              //   name: "Address",
              //   open: false,
              // },
              {
                name: "Applicant’s Contact Information",
                open: false,
              },
              // {
              //   name: 'Parents Information',
              //   open: false
              // },
              // {
              //   name: "Legal Guardian Information",
              //   open: false,
              // },

              {
                name: "English Proficiency Assessment",
                open: false,
              },
              // {
              //   name: "Health Information",
              //   open: false,
              // },
              {
                name: "Sources",
                open: false,
              },
              {
                name: "Funding Source",
                open: false,
              },
              {
                name: "Policies",
                open: false,
              },
            ],
          });
        } else {
          this.setState({
            activeSections: [
              {
                name: "Applicant Personal Information",
                open: false,
              },
              {
                name: "Official Identification",
                open: false,
              },
              {
                name: "Education",
                open: false,
              },
              {
                name: "Program of Study",
                open: accordionValue,
              },
              {
                name: "Work Experience",
                open: false,
              },
              // {
              //   name: "Address",
              //   open: false,
              // },
              {
                name: "Applicant’s Contact Information",
                open: false,
              },
              // {
              //   name: 'Parents Information',
              //   open: false
              // },
              // {
              //   name: "Legal Guardian Information",
              //   open: false,
              // },

              {
                name: "English Proficiency Assessment",
                open: false,
              },
              // {
              //   name: "Health Information",
              //   open: false,
              // },
              {
                name: "Sources",
                open: false,
              },
              {
                name: "Funding Source",
                open: false,
              },
              {
                name: "Policies",
                open: false,
              },
            ],
          });
        }
        break;
      case "Add":
        this.setState({ address: data });
        const { errorAdd } = this.state;
        const errorAddKeys = Object.keys(errorAdd);
        if (errorAddKeys.length) {
          const returnValue = this.addressCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[5] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "Contact":
        // const contactinfo = data;
        // console.log(data)
        this.setState({ contactInformations: data });
        const { errorContact } = this.state;
        let counts = 0;
        const errorMainKeys = Object.keys(errorContact);
        if (errorMainKeys.length) {
          const returnValue = this.contactCheck(data);
          for (const element in errorContact) {
            if (Object.prototype.hasOwnProperty.call(errorContact, element)) {
              const errorContactKeys = Object.keys(element);
              if (errorContactKeys.length) {
                if (returnValue !== 1) {
                  counts = 1;
                }
              }
            }
          }
          if (counts === 0) {
            const count = Array.from(this.state.count);
            count[6] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "PSI":
        this.setState({ parentsInformation: data });
        const { errorParent } = this.state;
        const errorParentKeys = Object.keys(errorParent);
        if (errorParentKeys.length) {
          const returnValue = this.parentsInformationCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[7] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "Guardian":
        this.setState({ guardianInformation: data });
        const { errorGuard } = this.state;
        const errorGuardKeys = Object.keys(errorGuard);
        if (errorGuardKeys.length) {
          const returnValue = this.guardianInformationCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[8] = 1;
            this.setState({ count: count });
          }
        }
        break;

      case "TS":
        this.setState({ testScores: data });
        const { errorTest } = this.state;
        /* const errorTestkeys = Object.keys(errorTest) */
        if (errorTest.length) {
          const returnValue = this.testScoresCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[9] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "HI":
        this.setState({ healthInformation: data });
        const { errorHI } = this.state;
        const errorHIKeys = Object.keys(errorHI);
        if (errorHIKeys.length) {
          const returnValue = this.healthInformationCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[10] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "Sources":
        this.setState({ sourceInformation: data });
        const { errorSources } = this.state;
        const errorSourcesKeys = Object.keys(errorSources);
        if (errorSourcesKeys.length) {
          const returnValue = this.sourcesCheck(data);
          if (returnValue === 1) {
            const count = Array.from(this.state.count);
            count[11] = 1;
            this.setState({ count: count });
          }
        }
        break;
      case "Policies":
        this.setState({ acceptedPolicies: data });
        break;
      default:
        break;
    }
  }

  //ALI
  toggleAccordion(index) {
    const { contactInformations } = this.state;
    let Allphonesobj = contactInformations.phoneNumberArray;

    let IsRepeated = false;
    let phoneNumbers = new Set();

    for (let contact of Allphonesobj) {
      let phoneNumber = contact.phoneNumber;

      if (phoneNumbers.has(phoneNumber)) {
        IsRepeated = true; // Found a repeated phone number
      } else {
        phoneNumbers.add(contact.phoneNumber);
      }
    }
    if (IsRepeated) {
      alert("Phone Number Already Added ");
      index = 5;
      const { activeSections } = this.state;
      const sectionsBody = [];
      activeSections.forEach((section, i) => {
        if (i === index) {
          section.open = true;
        } else {
          section.open = false;
        }
        sectionsBody.push(section);
      });
      this.setState({ activeSections: sectionsBody });
      return;
    }

    const { activeSections } = this.state;
    const sectionsBody = [];
    activeSections.forEach((section, i) => {
      if (i === index) {
        section.open = !section.open;
      } else {
        section.open = false;
      }
      sectionsBody.push(section);
    });
    this.setState({ activeSections: sectionsBody });
  }

  toggleAll() {
    const { activeSections } = this.state;
    const sectionsBody = [];
    activeSections.forEach((section, i) => {
      section.open = false;
      sectionsBody.push(section);
    });
    this.setState({ activeSections: sectionsBody });
  }

  getDefaultValue(componentName, data) {
    switch (componentName) {
      case "Add":
        this.setState({
          address: { ...this.state.address, addressType: data },
        });
        break;
      case "Contact":
        if (
          this.state.contactInformations &&
          this.state.contactInformations.phoneNumberArray &&
          this.state.contactInformations.phoneNumberArray.length > 0
        ) {
          const phoneNumberArray =
            this.state.contactInformations.phoneNumberArray;
          const length = phoneNumberArray.length;
          phoneNumberArray.forEach((element, i) => {
            if (i === length - 1) {
              element.phoneType = data;
            }
          });
          this.setState({
            contactInformations: {
              ...this.state.contactInformation,
              phoneNumberArray: phoneNumberArray,
            },
          });
        }
        break;
      case "Parent":
        if (
          this.state.parentsInformation &&
          this.state.parentsInformation.fatherPrefix &&
          this.state.parentsInformation.motherPrefix
        ) {
          this.setState({
            parentsInformation: {
              ...this.state.parentsInformation,
              fatherPrefix: data.fatherDefault,
              motherPrefix: data.motherDefault,
            },
          });
        }
        break;
      default:
        break;
    }
  }

  async handleSave() {
    const {
      personalInformation,
      ai,
      fs,
      governmentInformation,
      workExperienceInformation,
      address,
      contactInformations,
      parentsInformation,
      guardianInformation,
      educationHistorys,
      healthInformation,
      sourceInformation,
      undergraduate,
      fatherId,
      motherId,
      testScores,
    } = this.state;
    const ci = [];

    if (
      contactInformations.phoneNumberArray &&
      contactInformations.phoneNumberArray.length > 0
    ) {
      //[A.M]
      const { contactInformations } = this.state;
      let Allphonesobj = contactInformations.phoneNumberArray;

      let IsRepeated = false;
      let phoneNumbers = new Set();

      for (let contact of Allphonesobj) {
        let phoneNumber = contact.phoneNumber;

        if (phoneNumbers.has(phoneNumber)) {
          IsRepeated = true; // Found a repeated phone number
        } else {
          phoneNumbers.add(contact.phoneNumber);
        }
      }

      if (IsRepeated) {
        alert("Phone Number Should not be repeated");

        return false;
      }

      contactInformations.phoneNumberArray.forEach((element) => {
        ci.push({
          PhoneType: element.phoneType,
          CountryId: element.phoneCountry,
          Email: contactInformations.email,
          PhoneNumber: element.phoneNumber,
          IsPrimary: element.isPrimary,
        });
      });
    }

    const eh = [];
    const errorCheck = ["", 0, null, undefined];
    if (
      educationHistorys.underGradDegree &&
      educationHistorys.underGradDegree.length >= 1
    ) {
      educationHistorys.underGradDegree.forEach((element) => {
        eh.push({
          selectedCategory: element.selectedCategory || "",
          CurriculumId: element.highSchoolCertificate,
          EndDate: element.endDate,
          InstitutionId: element.highSchoolName,
          InstitutionName: element.institutionName,
          CountryId: element.selectedCountry,
          TransferedInstitutionId: element.perviousUniversity,
          TransferedInstitutionName: element.perviousUniversityName,
          TransferredCerti: element.previousUniversityCertificate,
          TransferredGPA: element.previousUniversityGPA,
          EducationGrade: element.educationGrade,
        });
      });
    }
    if (
      errorCheck.indexOf(educationHistorys.highSchoolCertificate) === -1 ||
      errorCheck.indexOf(educationHistorys.highSchoolName) === -1 ||
      errorCheck.indexOf(educationHistorys.selectedCountry) === -1 ||
      errorCheck.indexOf(educationHistorys.perviousUniversity) === -1 ||
      errorCheck.indexOf(educationHistorys.endDate) === -1
    ) {
      eh.push({
        selectedCategory: educationHistorys.selectedCategory || "",
        CurriculumId: educationHistorys.highSchoolCertificate,
        EndDate: educationHistorys.endDate,
        InstitutionId: educationHistorys.highSchoolName,
        InstitutionName: educationHistorys.institutionName,
        CountryId: educationHistorys.selectedCountry,
        TransferedInstitutionId: educationHistorys.perviousUniversity,
        TransferedInstitutionName: educationHistorys.perviousUniversityName,
        TransferredCerti: educationHistorys.previousUniversityCertificate,
        TransferredGPA: educationHistorys.previousUniversityGPA,
        EducationGrade: educationHistorys.educationGrade,
      });
      //console.log("EH");
      //console.log(eh);
    }

    const we = [];
    const errorCheck1 = ["", 0, null, undefined];
    if (
      errorCheck1.indexOf(workExperienceInformation.Company) === -1 ||
      errorCheck1.indexOf(workExperienceInformation.Position) === -1 ||
      errorCheck1.indexOf(workExperienceInformation.StartDate) === -1 ||
      errorCheck1.indexOf(workExperienceInformation.EndDate) === -1
    ) {
      we.push({
        EmployerName: workExperienceInformation.Company || "",
        Position: workExperienceInformation.Position || "",
        StartDate: workExperienceInformation.StartDate || "",
        EndDate: workExperienceInformation.EndDate || "",
      });
    }

    const sources = [];
    if (sourceInformation) {
      if (
        sourceInformation.selectedSources &&
        sourceInformation.selectedSources.length > 0
      ) {
        sourceInformation.selectedSources.forEach((element) => {
          sources.push({
            SourceId: element,
          });
        });
      }
    }
    const tests = [];
    if (testScores.tests && testScores.tests.length > 0) {
      testScores.tests.forEach((element) => {
        if (
          !(
            errorCheck.indexOf(element.test) !== -1 &&
            errorCheck.indexOf(element.testType) !== -1 &&
            errorCheck.indexOf(element.dateTaken) !== -1 &&
            !element.score
          )
        ) {
          tests.push({
            Test: element.test,
            TestType: element.testType,
            Score: element.score,
            DateTaken: element.dateTaken,
          });
        }
      });
    }
    // eslint-disable-next-line no-unused-vars
    const fetchBody = {
      IncompleteApplicationId:
        this.props.incompleteApplicationId || sessionStorage.getItem("id"),

      FundingSource: fs.selectedFundingSource || "",
      // Personal Information
      FirstName: personalInformation.fName || "",
      MiddleName: personalInformation.mName || "",
      LastName: personalInformation.lName || "",
      DateOfBirth: personalInformation.dateOfBirth || "",
      CountryOfBirth: personalInformation.selectedCountry || "",
      Nationality: personalInformation.selectedNationality || "",
      Gender: personalInformation.selectedGender || "",
      SiblingFName: personalInformation.siblingFName || "",
      SiblingMName: personalInformation.siblingMName || "",
      SiblingLName: personalInformation.siblingLName || "",
      SiblingTKHNumber: personalInformation.siblingTKHNumber || "",
      ArabicData: [
        {
          ColumnName: "ARABIC_FIRSTNAME",
          ColumnValue: personalInformation.arabicText1 || "",
        },
        {
          ColumnName: "ARABIC_MIDDLENAME",
          ColumnValue: personalInformation.arabicText2 || "",
        },
        {
          ColumnName: "ARABIC_LASTNAME",
          ColumnValue: personalInformation.arabicText3 || "",
        },
      ],
      // Program of Study

      UniversityId: ai.selectedUniversity || "",
      SecondUniversityId: ai.selectedSecondUniversity || "",
      SecondProgramId: ai.selectedSecondProgram || "",
      SecondMajorId: ai.selectedSecondMajor || "",
      ScheduleId: ai.selectedSchedule || "",
      Level: ai.selectedLevel || "",
      SecondLevel: ai.selectedSecondLevel || "",
      ProgramOfStudyId: ai.selectedMajor || "",
      Description: ai.description || "",
      SecDescription: ai.secondDescription || "",
      EntryTerm: ai.selectedEntryTerm || "",
      ProgramId: ai.selectedProgram || "",
      PreferredLanguage: ai.selectedLanguage || "",
      //selectedlanguage
      // Government Information
      nationalIdNumber: governmentInformation.nationalNumber || "",
      passportNumber: governmentInformation.passportNumber || "",
      passportCountryIssued: governmentInformation.passportCountry || "",
      passportExpirationDate: governmentInformation.passportExpiryDate || "",
      // Address
      AddressTypeId: address.addressType || "",
      Line1: address.addressLine1 || "",
      Line2: address.addressLine2 || "",
      Country: address.selectedCountry || "",
      City: address.selectedCity || "",
      // Contact
      ContactInformation: ci.length > 0 ? ci : null,
      // Parents Information
      FatherPrefix: parentsInformation.fatherPrefix || "",
      FatherRelationType: fatherId || "",
      FatherFirstName: parentsInformation.fatherFName || "",
      FatherMiddleName: parentsInformation.fatherMName || "",
      FatherFamilyName: parentsInformation.fatherLName || "",
      FatherProfession: parentsInformation.fatherProfession || "",
      FatherCompany: parentsInformation.fatherCompany || "",
      FatherCompanyAddress: parentsInformation.fatherCompanyAddress || "",
      FatherMobileNumber: parentsInformation.fatherPhone || "",
      FatherEmail: parentsInformation.fatherEmail || "",
      FatherAddress: parentsInformation.fatherAddress || "",
      FatherAttendedInstitution:
        parentsInformation.fatherAttendedInstitution || false,
      FatherDeceased: parentsInformation.fatherDeceased || false,
      MotherPrefix: parentsInformation.motherPrefix || "",
      MotherRelationType: motherId || "",
      MotherFirstName: parentsInformation.motherFName || "",
      MotherMiddleName: parentsInformation.motherMName || "",
      MotherFamilyName: parentsInformation.motherLName || "",
      MotherProfession: parentsInformation.motherProfession || "",
      MotherCompany: parentsInformation.motherCompany || "",
      MotherCompanyAddress: parentsInformation.motherCompanyAddress || "",
      MotherMobileNumber: parentsInformation.motherPhone || "",
      MotherEmail: parentsInformation.motherEmail || "",
      MotherAddress: parentsInformation.motherAddress || "",
      MotherAttendedInstitution:
        parentsInformation.motherAttendedInstitution || false,
      MotherDeceased: parentsInformation.motherDeceased || false,
      // Guardian Information
      GuardianPrefix: guardianInformation.guardianPrefix || "",
      GuardianRelationType: guardianInformation.guardianRelationship || "",
      GuardianFirstName: guardianInformation.guardianFName || "",
      GuardianMiddleName: guardianInformation.guardianMName || "",
      GuardianFamilyName: guardianInformation.guardianLName || "",
      GuardianProfession: guardianInformation.guardianProfession || "",
      GuardianMobileNumber: guardianInformation.guardianPhone || "",
      GuardianEmail: guardianInformation.guardianEmail || "",
      GuardianAddress: guardianInformation.guardianAddress || "",
      // Work Experience
      Employment: we.length > 0 ? we : null,
      // Education
      EducationHistory: eh.length > 0 ? eh : null,
      // Tests
      Tests: tests.length > 0 ? tests : null,
      // Health Information
      hasBeenIll: healthInformation.hasIllness || false,
      illnessDescription: healthInformation.illness || "",
      // Source Information
      SourceInformation: sources.length > 0 ? sources : null,
      OtherSource: sourceInformation ? sourceInformation.otherSource : null,
    };
    //console.log(eh);
    //console.log(JSON.stringify(fetchBody));
    return fetch(`${process.env.REACT_APP_API_URL}/api/Save/SaveApplication`, {
      method: "POST",
      body: JSON.stringify(fetchBody),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.StatusCode === 200) {
          this.setState({ saveProcessing: false });
          sessionStorage.setItem("isBlocking", false);
          return 1;
        } else {
          this.setState({ saveProcessing: false });
          this.setState({ policyError: "Some Error Occured!", color: "red" });
          return 0;
        }
      })
      .catch((err) => {
        this.setState({ saveProcessing: false });
        console.log(err);
        this.setState({ policyError: "Some Error Occured", color: "red" });
      });
  }

  async submit() {
    this.setState({ nextProcessing: true });

    return fetch(
      `${process.env.REACT_APP_API_URL}/api/Validate/ValidateApplication`,
      {
        method: "POST",
        body: JSON.stringify({
          IncompleteApplicationId:
            this.props.incompleteApplicationId || sessionStorage.getItem("id"),
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.StatusCode === 200) {
          this.props.onSubmit();
          this.setState({ nextProcessing: false });
        } else if (res.StatusCode === 404) {
          this.setState({ nextProcessing: false });
          const error = [];
          if (res.Msg.ProgramOfStudyId || res.Msg.ProgramId) {
            this.setState({
              errorAI: {
                selectedMajor: res.Msg.ProgramOfStudyId
                  ? "Please check this value"
                  : null,
                selectedProgram: res.Msg.ProgramId
                  ? "Please check this value"
                  : null,
              },
            });
            error.push("Program of Study");
          }
          if (res.Msg.GovernmentId) {
            this.setState({
              errorGI: { nationalNumber: "Please Enter the value" },
            });
            error.push("Official Identification");
          }
          if (
            res.Msg.Company ||
            res.Msg.Position ||
            res.Msg.StartDate ||
            res.Msg.EndDate
          ) {
            this.setState({
              errorWE: {
                Company: res.Msg.Position ? "Please check this value" : null,
                Position: res.Msg.Company ? "Please check this value" : null,
                StartDate: res.Msg.StartDate ? "Please add a date" : null,
                EndtDate: res.Msg.EndDate ? "Please add a date" : null,
              },
            });
            error.push("Work Experience");
          }
          if (res.Msg.AddressTypeId) {
            this.setState({
              errorAdd: { addressType: "Please select a value" },
            });
            error.push("Address");
          }

          if (res.Msg.TestType) {
            this.setState({
              errorTest: {
                TestType: "Please select all test type for the selected test",
              },
            });
            error.push("English Proficiency Assessment : ");
          }

          if (res.Msg.ExistsTestType) {
            this.setState({
              testTypeError:
                `English Proficiency Assessment :` + res.Msg.ExistsTestType,
              color: "red",
            });
          }
          this.setState({
            policyError: `${error.join(
              ", "
            )} Please enter all test type for the choosen test(s).`,
            color: "red",
          });
          // this.setState({ policyError: `${error.join(', ')} section(s) have error(s) in them.`, color: 'red' })
          this.conditionCheck();
        }
      })
      .catch((err) => {
        this.setState({ nextProcessing: false });
        console.log(err);
      });
  }

  render() {
    const {
      error,
      policyError,
      testTypeError,
      loading,
      color,
      acceptedPolicies,
      saved,
      activeSections,
      count,
      saveProcessing,
      nextProcessing,
    } = this.state;
    if (loading) {
      return (
        <div id="mainContainer">
          <div id="designBorder">
            <div
              id="main-page"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={loader}
                style={{
                  justifyContent: "center",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                alt="Loading..."
              />
            </div>
          </div>
        </div>
      );
    }
    if (error) {
      return (
        <div id="mainContainer">
          <div id="designBorder">
            <div id="main-page">
              <p style={{ color: "red", maxWidth: "calc(100% - 150px)" }}>
                {error}
              </p>
              <button
                className="save"
                onClick={() => {
                  sessionStorage.setItem("isBlocking", false);
                  this.props.onClick();
                }}
                id="logout-button"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      );
    }
    const accordionSections = [];
    activeSections.forEach((element, i) => {
      if (activeSections.length === 12 && i >= 9) {
        accordionSections.push(
          <div key={i}>
            <div
              className={"accordion " + (element.open ? "open" : "")}
              key={i}
            >
              <div
                className="accordionSectionHeader"
                onClick={() => this.toggleAccordion(i)}
              >
                <span
                  className="accordionSectionHeaderContent"
                  style={
                    count[i] === 0
                      ? {
                          backgroundColor: "white",
                          color: "red",
                          borderWidth: 1,
                          borderColor: "red",
                          borderStyle: "solid",
                          boxSizing: "border-box",
                        }
                      : null
                  }
                >
                  {count[i] === 0 ? "!" : `${i + 1}`}
                </span>
                <span
                  className="acc-heading"
                  style={count[i] === 0 ? { color: "red" } : null}
                >
                  {element.name}
                </span>
              </div>
              <div className="accordion-form">{this.getActiveTabBody(i)}</div>
            </div>
          </div>
        );
      } else {
        accordionSections.push(
          <div key={i}>
            <div
              className={"accordion " + (element.open ? "open" : "")}
              key={i}
            >
              <div
                className="accordionSectionHeader"
                onClick={() => this.toggleAccordion(i)}
              >
                <span
                  className="accordionSectionHeaderContent"
                  style={
                    count[i] === 0
                      ? {
                          backgroundColor: "white",
                          color: "red",
                          borderWidth: 1,
                          borderColor: "red",
                          borderStyle: "solid",
                          boxSizing: "border-box",
                        }
                      : null
                  }
                >
                  {count[i] === 0 ? "!" : `${i + 1}`}
                </span>
                <span
                  className="acc-heading"
                  style={count[i] === 0 ? { color: "red" } : null}
                >
                  {element.name}
                </span>
              </div>
              <div className="accordion-form">{this.getActiveTabBody(i)}</div>
            </div>
          </div>
        );
      }
    });

    return (
      <>
        {saved ? (
          <div className="alert-box">
            <div className="alert-box-header">
              <p>Application Saved</p>
              <p
                onClick={() => this.setState({ saved: false })}
                style={{ cursor: "pointer" }}
              >
                X
              </p>
            </div>
            <div className="alert-box-body">
              <p>Your application has been saved</p>
            </div>
            <div className="alert-box-footer">
              <button
                className="save"
                onClick={() => {
                  this.setState({ saved: true });
                  this.props.onClick();
                }}
              >
                Ok
              </button>
            </div>
          </div>
        ) : null}
        <div id={saved ? "mainContainer-blur" : "mainContainer"}>
          <div id="designBorder">
            <img
              src={logo}
              className="center main-logo"
              style={{ paddingTop: 20 }}
            ></img>
            <div id="main-page">
              <div id="applicationForm">
                <h4 className="app-heading">Application Form</h4>
                {/* <p style={{fontWeight:'bold'}}>Undergraduate application instructions:</p> */}
                <button
                  className="save"
                  onClick={() => {
                    this.props.onClick();
                  }}
                  id="logout-button"
                >
                  Logout
                </button>
                <div id="header">
                  <p style={{ color: "red" }}>* = Field is Required</p>
                  <p style={{ color: "red" }}>
                    ** Please type your answer in the same language of the field
                    question
                  </p>
                </div>
              </div>
              <br />
              {policyError && <p style={{ color: color }}>{policyError}</p>}
              {testTypeError && <p style={{ color: color }}>{testTypeError}</p>}
              {accordionSections}
              <div className="main-button">
                <button
                  className="save"
                  onClick={() => {
                    this.setState({ saveProcessing: true });
                    this.toggleAll();
                    this.setState({ policyError: "" });
                    this.setState({ testTypeError: "" });
                    this.handleSave().then((res) => {
                      if (res === 1) {
                        this.setState({ saved: true });
                      } else {
                        this.setState({ saveProcessing: false });
                      }
                    });
                  }}
                  disabled={saveProcessing}
                >
                  {saveProcessing ? (
                    <img
                      src={submit}
                      alt="Loading..."
                      style={{ width: 18, height: 18 }}
                    />
                  ) : (
                    "Save and Exit"
                  )}
                </button>

                <button
                  className="save"
                  onClick={() => {
                    this.setState({ nextProcessing: true });
                    this.setState({ policyError: "" });
                    this.setState({ testTypeError: "" });
                    const count = this.conditionCheck();
                    if (count.indexOf(0) === -1) {
                      this.handleSave().then((res) => {
                        if (res === 1) {
                          this.submit();
                        } else {
                          this.setState({ nextProcessing: false });
                        }
                      });
                    } else {
                      this.setState({ nextProcessing: false });
                    }
                  }}
                  disabled={!acceptedPolicies || nextProcessing}
                >
                  {nextProcessing ? (
                    <img
                      src={submit}
                      alt="Loading..."
                      style={{ width: 18, height: 18 }}
                    />
                  ) : (
                    "Next"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
SuccessPage.propTypes = {
  incompleteApplicationId: PropTypes.number,
  token: PropTypes.string,
  // onSubmit: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  //history: PropTypes.object,

  onLogin: PropTypes.func.isRequired,
  history: PropTypes.object,
};
